var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',{staticClass:"not-copy"},[(_vm.officeType.office === 0)?_c('GreenGrassOfficeR',{attrs:{"width":_vm.width,"height":_vm.height,"virtualOfficeRoom":_vm.officeType.virtual_office_room}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c2a1ccaa","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/DashBoard/VirtualOffice/Room.vue
// module id = null
// module chunks = 